<form [formGroup]="form">
    <mat-form-field appearance="outline" class="always-outline">
        <mat-select [placeholder]="placeholder" formControlName="item" multiple panelClass="custom-panel" [matTooltip]="selectedText" [disableOptionCentering]="true">
            <mat-select-trigger class="select-trigger-text" *ngIf="selectedText">
                {{selectedText}}
            </mat-select-trigger>
            <mat-option *ngIf="heading" disabled class="select-box-heading">{{heading}}</mat-option>
            <mat-option *ngIf="allowSelectAll" class="select-boxes" (click)="toggleAllSelection()" [value]="selectAllValue">
                <kt-chip label='Select All' borderRadius='large' height='small'></kt-chip>
            </mat-option>

            <mat-divider *ngIf="heading || allowSelectAll"></mat-divider>
            <mat-option (click)="emitSelections()" class="select-boxes" *ngFor="let item of items" [value]="item">
                <kt-chip [label]="item.label" [backgroundColor]="item.backgroundColor" [labelColor]="item.labelColor" borderRadius='large' height='small'></kt-chip>
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>